import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import cx from 'clsx';

import { Banner, BannerDark } from '@/assets/welcome';
import { CustomTitle } from '@/components/CustomTitle';
import { useCurrentAddressInfo, useTheme, useConnectedAddress } from '@/hooks';
import { openInDebank } from '@/utils';

import styles from './index.module.scss';
import config from './config';

export const MobileContainer = ({ landingToMobile }: { landingToMobile?: boolean }) => {
  const { t } = useTranslation();

  const history = useHistory();
  const { isDark } = useTheme();
  const { address } = useCurrentAddressInfo();
  const imgUrl = isDark ? BannerDark : Banner;
  const connectedAddress = useConnectedAddress();
  // const forceSetPc = useForceSetPc();

  const isLandingPage = !(history?.location?.pathname === '/');
  const isHiChatPage = history?.location?.pathname?.startsWith('/hi');
  const targetUserId = history?.location?.pathname.match(/hi\/(.*)/)?.[1];

  useEffect(() => {
    if (isHiChatPage && targetUserId) {
      const targetLink = `hi/${targetUserId}`;
      openInDebank({ link: targetLink, showDownloadGuide: false });
    }
  }, [isHiChatPage, targetUserId]);

  // const handleForcePc = useCallback(() => {
  //   forceSetPc();
  // }, [forceSetPc]);

  const nextAddress = address || connectedAddress;
  if (nextAddress && !isLandingPage) {
    history.replace(`/profile/${nextAddress}`);
    return null;
  }

  return (
    <>
      <CustomTitle titlePrefix="Login" />
      <div className={cx(styles.container, styles.mobile)}>
        <div className={cx(styles.bannerContainer, isDark && styles.isDark)}>
          {isLandingPage ? (
            landingToMobile ? (
              <div className={styles.tips}>
                <p>{t('Welcome.1codfhk')}</p>
                <p>{t('Welcome.kqaf8u')}</p>
              </div>
            ) : (
              <div className={cx(styles.tips, styles.landingPcTips)}>
                <p className={styles.landingPcTitle}>
                  {t('Welcome.yo97f')}
                  <br />
                  {t('Welcome.1vss7n8')}
                </p>
                {/* <Button className={styles.forcePcBtn} type="primary">
                  {t('Welcome.105hahf')}
                </Button> */}
              </div>
            )
          ) : null}
          <div className={styles.bannerInner}>
            <div className={styles.bannerContent}>
              <div className={styles.title}>{t('Welcome.18tax4x')}</div>
              <div className={styles.desc}>{t('Welcome.1df0jl8')}</div>
            </div>
            <img className={styles.bannerPic} src={imgUrl} alt="banner" />
          </div>
        </div>
        <div className={cx(styles.contentContainer, isDark && styles.isDark)}>
          <div className={styles.contentInner}>
            <div className={styles.appIntroContainer}>
              {config.map(({ title, desc, img, imgDark }, index) => (
                <div key={index} className={styles.appIntro}>
                  <img className={styles.introPic} src={isDark ? imgDark : img} alt="intro" />
                  <div className={styles.introContent}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.desc}>{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
